import React from 'react';
import classNames from 'classnames';

import type { GlobalRatingItem } from '../types';

type Classes = {
  label?: string;
};

interface RatingItemProps {
  rating: number;
  description: string;
  classes?: Classes;
}

function RatingItem({ rating, description, classes }: RatingItemProps) {
  return (
    <div className="global-rating-item d-flex align-items-center gap-x-16">
      <p className="rating">{rating}</p>
      <p className={classNames('description', classes?.label)}>{description}</p>
    </div>
  );
}

interface Props {
  globalRatings: GlobalRatingItem[];
  classes?: Classes;
}

function GlobalRatingList({ globalRatings, classes }: Props) {
  return (
    <div className="global-rating-list">
      {globalRatings.map(({ rating, description }) => {
        return <RatingItem rating={rating} description={description} key={rating} classes={classes} />;
      })}
    </div>
  );
}

export default GlobalRatingList;
